import { Api, LogManager } from "@mcleod/core";

const log = LogManager.getLogger("DistanceProfileService");

/**
 * Service to retrieve distance profile information
 */
export class DistanceProfileService {
    /**
     * Get the current distance profile vendor information
     * @param distanceProfileKey Optional distance profile key, will use default if not provided
     * @returns Promise with the distance profile information
     */
    public static async getDistanceVendorInfo(distanceProfileKey?: string): Promise<DistanceVendorInfo> {
        try {
            const params: any = {};
            if (distanceProfileKey) {
                params.distance_profile_key = distanceProfileKey;
            }

            const response = await Api.search("lme/dispatch/distance-profile-lookup", params);

            log.debug('Distance profile lookup response:', response);

            // Handle array response structure
            // The API returns an array with data inside it
            let source = '';
            let lookupType = '';
            let method = '';

            if (response && response.data && Array.isArray(response.data) && response.data.length > 0) {
                const data = response.data[0];
                source = data.source || '';
                lookupType = data.lookup_type || '';
                method = data.method || '';
            } else if (response) {
                // Fallback to direct properties if response structure changes
                source = response.source || '';
                lookupType = response.lookup_type || '';
                method = response.method || '';
            }

            return {
                source,
                lookupType,
                method,
                isMileMaker: source === 'E', // 'E' is MileMaker
                isPcMiler: source === 'A' || source === 'T', // 'A' is PC*Miler On Prem, 'T' is PC*Miler Web
            };
        } catch (error) {
            console.error("Error fetching distance vendor info:", error);
            return {
                source: '',
                lookupType: '',
                method: '',
                isMileMaker: false,
                isPcMiler: false
            };
        }
    }
}

export interface DistanceVendorInfo {
    source: string;
    lookupType: string;
    method: string;
    isMileMaker: boolean;
    isPcMiler: boolean;
    isPcMilerWeb?: boolean;
}
